import { render, staticRenderFns } from "./printCenter.vue?vue&type=template&id=54b0c4a8&"
import script from "./printCenter.vue?vue&type=script&lang=js&"
export * from "./printCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports